(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmOutboundReferralStatusSearch', CrmOutboundReferralStatusSearch);

    CrmOutboundReferralStatusSearch.$inject = ['$resource'];

    function CrmOutboundReferralStatusSearch($resource) {
        var resourceUrl =  'api/_search/crm-outbound-referral-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
